import {useState} from "../../__snowpack__/pkg/react.js";
import {createModel} from "../../__snowpack__/pkg/hox.js";
import {axios} from "../lib/axios.js";
import {handleError} from "../lib/errorHandler.js";
export const useShops = () => {
  const [data, setData] = useState([]);
  const [dataMap, setDataMap] = useState({});
  const [loading, setLoading] = useState(false);
  const fetchData = async (pageInfo, query) => {
    setLoading(true);
    try {
      const {
        data: {content, number: page, size: pageSize, totalElements: pageTotal}
      } = await axios.post("/saas/shop/list", {
        page: pageInfo && pageInfo.page && pageInfo.page - 1,
        size: pageInfo && pageInfo.pageSize,
        ...query
      });
      let shopDataMap = {};
      setData(content);
      content.map((data2) => {
        shopDataMap[data2.shopId] = data2;
      });
      setDataMap(shopDataMap);
      return {
        shops: content,
        shopsPageInfo: {
          page: page + 1,
          pageSize,
          pageTotal
        }
      };
    } catch (error) {
      handleError(error);
      return {
        shops: data,
        shopsPageInfo: pageInfo
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    shopsLoading: loading,
    shops: data,
    setShops: setData,
    shopDataMap: dataMap,
    fetchShops: fetchData
  };
};
export const useShop = () => {
  const [shop, setShop] = useState(void 0);
  const [shops, setShops] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (props = {}) => {
    const {size = 100, id = void 0, isNeedPage = true, excludeChannels} = props;
    setLoading(true);
    try {
      const {
        data: {content}
      } = await axios.post("/saas/shop/list", {
        shopId: id,
        page: 0,
        size,
        isNeedPage,
        excludeChannels
      });
      setShop(content[0]);
      setShops(content);
      return {shop: content[0], shops: content};
    } catch (error) {
      handleError(error);
      return {shop: void 0, shops: []};
    } finally {
      setLoading(false);
    }
  };
  const syncStore = async (shopId) => {
    try {
      let {data} = await axios.post(`/saas/shop/${shopId}/sync-all`);
      return data?.result || false;
    } catch (error) {
      handleError(error);
      return false;
    } finally {
      setLoading(false);
    }
  };
  return {
    loading,
    shop,
    shops,
    fetchData,
    syncStore
  };
};
export const useShopsModel = createModel(useShops);
export const useShopModel = createModel(useShop);
